import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { InitializedQuizApiModel } from '@app/api/api-models';

@Component({
  templateUrl: './start-quiz-modal.component.html',
  styleUrls: ['./start-quiz-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class StartQuizModalComponent {
  @Input()
  public quiz: InitializedQuizApiModel;

  @Input()
  public confirm: Function;

  @Input()
  public reject: Function;

  @HostBinding('class')
  public modalType = 'grey';

  constructor(private readonly bsModalRef: BsModalRef) {}

  private closeModal(): void {
    this.bsModalRef.hide();
  }

  public cancel(): void {
    this.reject();
    this.closeModal();
  }

  public proceed(): void {
    this.confirm();
    this.closeModal();
  }
}
